import React from 'react';
import cn from 'classnames';
import { ProgressBarEnum } from '../../types';
import styles from './stepper-form.module.css';
export const StepsIndicator = React.memo(({ progressBar, currentStepIndex, stepsLength, background, }) => {
    if (progressBar === ProgressBarEnum.LinearBar) {
        return (React.createElement("div", { className: cn(styles[`background-${background}`]) },
            React.createElement(ProgressBar, { width: (currentStepIndex / (stepsLength || 1)) * 100 })));
    }
    if (progressBar === ProgressBarEnum.Steps) {
        return React.createElement("div", { className: styles.numSteps }, `шаг ${currentStepIndex + 1}/${stepsLength}`);
    }
    return null;
});
const ProgressBar = ({ width }) => {
    return (React.createElement("div", { className: styles.progressBarContainer },
        React.createElement("div", { className: styles.progress, style: { right: `${(100 - width).toFixed(2)}%` } })));
};
//# sourceMappingURL=steps-indicator.js.map